/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 30.08.2016.
 */

import EmbeddedProfile from './embedded-profile';

export default EmbeddedProfile;



// WEBPACK FOOTER //
// ./src/components/ShowcaseCollection/EmbeddedProfile/index.js